/**
 * 全局配置文件
 */

// API基础URL，根据环境变量决定使用哪个API地址
// 确保正确指向Cloudflare Worker地址
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://web-api.openaitool.cn/api';

console.log('当前API地址:', API_BASE_URL);

// 其他全局配置
export const APP_CONFIG = {
  // 分页默认大小
  DEFAULT_PAGE_SIZE: 10,
  
  // 文件上传大小限制 (3MB)
  MAX_UPLOAD_SIZE: 3 * 1024 * 1024,
  
  // 默认图片
  DEFAULT_AVATAR: '/images/default-avatar.png',
  
  // 代码编辑器配置
  CODE_EDITOR: {
    theme: 'vs-dark',
    fontSize: 14,
    tabSize: 2
  },
  
  // 支持的编程语言列表
  SUPPORTED_LANGUAGES: [
    { id: 'python', name: 'Python', version: '3.9' },
    { id: 'javascript', name: 'JavaScript', version: 'ES6' },
    { id: 'java', name: 'Java', version: '11' },
    { id: 'cpp', name: 'C++', version: '17' },
    { id: 'c', name: 'C', version: 'C11' }
  ]
}; 